import React from "react";

const Flags = ({ aboveTentClass }) => {
  return <div className={`flags-wrapper ${aboveTentClass}`}></div>;
};

export default Flags;
